// eslint-disable-next-line no-redeclare
/* global $ */

import lodash from 'lodash';

/**
 * Tags Filter component functionality.
 *
 * @requires lodash
 * @author Peter van Gennip <peter.van.gennip@valtech.com>
 * @author Martijn Wennekes <martijn.wennekes@valtech.com>
 * @version 1.0
 * @date March 2019
 */
class OtcMessage {
    constructor($element) {
        this.$element = $($element);
        this.$messageblock = $($element).find('.js-otc-message');
    }

    /**
     * checks viewport and orientation
     * @returns  {boolean} true or false.
     */
    checkViewport() {
        let showMessage = false;
        let isMobile = window.matchMedia('only screen and (max-width: 992px) and (orientation: landscape)').matches;
        if (viewport.is('<md') || isMobile) {
            return (showMessage = true);
        }
        return showMessage;
    }

    /**
     * shows element with message if viewport < md
     */
    showMobileMessageOtc() {
        if (this.checkViewport()) {
            $(this.$messageblock).addClass('is-active');
        } else {
            if ($(this.$messageblock).is(':visible')) {
                $(this.$messageblock).removeClass('is-active');
            }
        }
    }

    /**
     * initializes component
     */
    init() {
        this.showMobileMessageOtc();

        // resize events
        $(window).on(
            'resize',
            lodash.debounce(() => {
                this.showMobileMessageOtc();
            }, 200)
        );
    }
}

export default OtcMessage;
